import { useEffect, useMemo, useContext } from 'react';
import * as Sentry from '@sentry/react';
import { AddressContext, AuthContext, CartContext } from 'constants/contexts';
import useConfig from './useConfig';

export default function useSentryUpdateEffect(params = {}, dependencies = []) {
  const { user } = useContext(AuthContext);
  const { parentIds, currentAddress } = useContext(AddressContext);
  const cart = useContext(CartContext);

  const orgId = useConfig('general.id');
  const context = useMemo(() => {
    const ctx = {
      orgId,
      parentIds,
      currentAddress,
    };
    if (cart?.items?.length) {
      ctx.cart = {
        items: cart.items.map((i) => JSON.stringify({
          id: i?.id,
          qty: i?.selection.qty,
          size: i?.selection.size,
          name: i?.name,
        })).join('\n'),
        scheduledTime: cart.scheduledTime,
      };
    }
    return ctx;
  }, [parentIds, cart, orgId, currentAddress]);

  useEffect(() => {
    const data = typeof params === 'function' ? params() : params;
    Sentry.configureScope((scope) => {
      // Todo: enable this if too much staled data linked to event
      // scope.clear();
      scope.setExtras({
        ...context,
        ...data,
      });
      scope.setUser({
        email: user?.email,
        phone: user?.phone,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context, ...dependencies]);
}
